import styled from 'styled-components/native';

interface ItemTouchableProps {
  active?: boolean;
}

export default styled.TouchableOpacity<ItemTouchableProps>``;
